<template>
  <v-container fluid>
    <section v-if="!fileData">
      <div class="gray--text">Loading....</div>
    </section>
    <section v-else>
      <section v-if="$store.getters[`isEmployee`]">
        <v-row>
          <v-col cols="12">
            <QuickNavigation :fileData="fileData" :routeHistory="$route" />
          </v-col>
        </v-row>
        <v-card tile flat>
          <v-container>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn type="submit" color="primary" @click="dialog = true">
                  Send notification
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table class="table--striped table--bordered" dense>
              <template v-slot:default>
                <thead>
                  <tr class="info">
                    <th class="white--text">User Name</th>
                    <th class="white--text">Type</th>
                    <th class="white--text">Send Date</th>
                    <th class="white--text">Notify to Lock Desk</th>
                    <th class="white--text">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="logHistory && logHistory.length > 0">
                    <tr
                      v-for="logItem in logHistory"
                      :key="logItem.emailNotificationId"
                      :title="logItem.emailNotificationId"
                    >
                      <td>{{ logItem.userName }}</td>
                      <td>
                        {{
                          $store.state.mstCodeEnums[
                            "emailNotificationType" +
                              logItem.emailNotificationType
                          ]
                        }}
                      </td>
                      <td>
                        {{
                          logItem.sentDateTime | moment("MM/DD/YYYY hh:mm A")
                        }}
                      </td>
                      <td>
                        <span
                          v-if="logItem.isExtraNotification"
                          class="success--text"
                        >
                          Yes
                        </span>
                        <span v-else class="error--text"> No </span>
                      </td>
                      <td>
                        <span v-if="logItem.isSuccess" class="success--text"
                          >Success</span
                        >
                        <span
                          v-else-if="
                            !logItem.isSuccess && logItem.retryCount > 2
                          "
                          class="error--text"
                          >Failure</span
                        >
                        <sapn v-else class="warning--text"
                          >Waiting to send</sapn
                        >
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td class="error--text text-center" colspan="5">
                        No Data
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card>
        <LoanDetailSubMenu />
      </section>
      <section v-else>
        <div class="error--text">This feature is only open to Underwriter</div>
      </section>
    </section>
    <v-dialog v-model="dialog" persistent max-width="900">
      <v-card tile :loading="templateLoading" :disabled="templateLoading">
        <v-card-title>
          Notification
          <v-spacer></v-spacer>
          <v-btn text icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form class="ma-6" ref="form">
            <v-select
              label="Select Template type"
              v-model="emailModel.emailNotificationType"
              item-text="displayName"
              item-value="codeValue"
              @change="getEmailTemplate()"
              :items="emailModel.emailNotificationTypeItems"
              hide-details="auto"
              dense
              outlined
            ></v-select>
            <v-combobox
              label="TO"
              class="my-2"
              v-model="emailModel.toList"
              @change="updateEmailList($event, 'to')"
              :rules="[required]"
              outlined
              chips
              clearable
              multiple
              dense
              hide-details="auto"
              append-icon=""
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="primary"
                  small
                  @click="select"
                  @click:close="removeToList(item, 'to')"
                >
                  {{ item }}
                </v-chip>
              </template>
            </v-combobox>
            <v-combobox
              label="CC"
              class="my-2"
              v-model="emailModel.ccList"
              @change="updateEmailList($event, 'cc')"
              outlined
              chips
              clearable
              multiple
              dense
              hide-details="auto"
              append-icon=""
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  small
                  color="primary"
                  @click="select"
                  @click:close="removeToList(item, 'cc')"
                >
                  {{ item }}
                </v-chip>
              </template>
            </v-combobox>
            <v-combobox
              label="BCC"
              class="my-2"
              v-model="emailModel.bccList"
              @change="updateEmailList($event, 'bcc')"
              outlined
              chips
              clearable
              multiple
              dense
              hide-details="auto"
              append-icon=""
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  small
                  color="primary"
                  @click="select"
                  @click:close="removeToList(item, 'bcc')"
                >
                  {{ item }}
                </v-chip>
              </template>
            </v-combobox>
            <v-text-field
              label="Subject"
              class="my-2"
              outlined
              dense
              v-model="emailModel.subject"
              :rules="[required]"
              hide-details="auto"
            ></v-text-field>
            <div class="mb-2">
              <div>Attachments:</div>
              <div class="d-flex">
                <v-chip
                  v-for="att in emailModel.attachments"
                  :key="att.id"
                  small
                  color="error"
                >
                  {{ att.displayName }}
                </v-chip>
              </div>
            </div>
            <div style="height: 350px">
              <quill-editor
                v-model="emailModel.body"
                class="quill-editor-style"
                ref="quillEditor"
                :options="editorOption"
              >
              </quill-editor>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="mx-2">
            <!-- If condition review has been selected -->
            <v-checkbox
              v-model="emailModel.isExtraNotification"
              label="Notify to Lock Desk"
            ></v-checkbox>
          </div>
          <v-btn
            color="secondary"
            class="mr-9"
            elevation="0"
            :loading="templateLoading"
            @click="sendCommitmentLetter"
            :disabled="
              emailModel.emailNotificationType === null ||
              emailModel.emailNotificationType === 0
            "
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { rules } from "@/mixins";
import QuickNavigation from "@/components/QuickNavigation";
import LoanDetailSubMenu from "@/components/LoanDetailSubMenu";

export default {
  name: "CommitmentLetterNotification",
  components: {
    QuickNavigation,
    LoanDetailSubMenu,
  },
  async mounted() {
    this.response = await this.getLoanDetail(
      this.$route.query.loanNumber
    ).catch((err) => err.response);

    if (this.response.status === 200) {
      this.fileData = this.response.data;
      this.logHistory = await this.getEmailNotificationHistory(
        this.$route.query.loanNumber
      )
        .then((resp) => resp.data)
        .catch(() => null);
    } else {
      this.$store.commit("statusDialog/showErrorDialog", this.response.data);
      this.$router.push("/pipeline");
    }

    this.initEmailModel();
  },
  data() {
    return {
      response: null,
      fileData: null,
      conditionalLoanApprovalLetterLoader: false,
      logHistory: [],
      dialog: false,
      templateLoading: false,
      emailModel: {
        fileDataId: null,
        from: null,
        toList: null,
        ccList: null,
        bccList: null,
        attachments: null,
        subject: null,
        body: null,
        templateHtml: null,
        emailNotificationType: null,
        emailNotificationTypeItems: [],
        isExtraNotification: false,
      },
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          ],
        },
        theme: "snow",
      },
    };
  },
  methods: {
    initEmailModel() {
      this.templateLoading = false;
      this.dialog = false;
      this.emailModel = {
        fileDataId: this.fileData.fileDataId,
        from: null,
        toList: null,
        ccList: null,
        bccList: null,
        attachments: null,
        subject: null,
        body: null,
        templateHtml: null,
        emailNotificationType: null,
        emailNotificationTypeItems: [],
        isExtraNotification: false,
      };

      this.emailModel.emailNotificationTypeItems = this.$store
        .dispatch("lookUpApi/getMstCodeVM", "emailNotificationType")
        .then((resp) => {
          this.emailModel.emailNotificationTypeItems = resp.filter(
            (x) => x.codeValue >= 10000
          );
        });
    },
    updateEmailList(emailList, type) {
      emailList[emailList.length - 1] = emailList[
        emailList.length - 1
      ].replaceAll(/\s/g, "");
      const isEmailFormat =
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          emailList[emailList.length - 1]
        );
      if (!isEmailFormat) {
        this.removeToList(emailList[emailList.length - 1], type);
      }
    },
    removeToList(item, type) {
      if (type === "to") {
        this.emailModel.toList.splice(this.emailModel.toList.indexOf(item), 1);
        this.emailModel.toList = [...this.emailModel.toList];
      } else if (type === "cc") {
        this.emailModel.ccList.splice(this.emailModel.ccList.indexOf(item), 1);
        this.emailModel.ccList = [...this.emailModel.ccList];
      } else if (type === "bcc") {
        this.emailModel.bccList.splice(
          this.emailModel.bccList.indexOf(item),
          1
        );
        this.emailModel.bccList = [...this.emailModel.bccList];
      }
    },
    async getEmailTemplate() {
      this.templateLoading = true;
      const res = await axios
        .get(
          `${process.env.VUE_APP_API_BASE_URL}/api/Feature/Notification/CommitmentLetterEmailTemplate?loanNumber=${this.fileData.fileName}&notificationType=${this.emailModel.emailNotificationType}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        )
        .then((resp) => resp)
        .catch((err) => err.response);

      if (res.status === 200) {
        console.log(res.data);
        this.emailModel.from = res.data.from;
        this.emailModel.toList = res.data.toList;
        this.emailModel.ccList = res.data.ccList;
        this.emailModel.bccList = res.data.bccList;
        this.emailModel.attachments = res.data.attachments;
        this.emailModel.subject = res.data.subject;
        this.emailModel.body = res.data.body;
        this.emailModel.templateHtml = res.data.templateHtml;
        this.emailModel.isExtraNotification = res.data.isExtraNotification;
      } else {
        this.initEmailModel();
        this.$store.commit("statusDialog/showErrorDialog", res.data);
      }
      this.templateLoading = false;
    },
    async getLoanDetail(loanNumber) {
      const resp = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/bytepro/filedata/Detail?loanNumber=${loanNumber}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      );

      return resp;
    },
    async getEmailNotificationHistory(loanNumber) {
      const resp = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/Feature/LogHistory/CommitmentLetterNotificationLog?loanNumber=${loanNumber}`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      );

      return resp;
    },
    async setStatusLockedFile(loanNumber, notifyLogId) {
      const resp = await axios.put(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/api/NWAPP/LockDesk/SetStatusLockedFile?loanNumber=${loanNumber}&status=${"COC"}&notifyLogId=${notifyLogId}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      );

      return resp;
    },
    async sendCommitmentLetter() {
      if (this.$refs.form.validate()) {
        this.templateLoading = true;

        const res = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/Feature/Notification/SendCommitmentLetter`,
          this.emailModel,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        );

        this.$store.commit(
          "statusDialog/showSuccessDialog",
          "Your email has been sent successfully."
        );

        if (res.status === 200) {
          const notifyId = res.data;

          this.logHistory = await this.getEmailNotificationHistory(
            this.$route.query.loanNumber
          )
            .then((resp) => resp.data)
            .catch(() => null);
          if (this.emailModel.isExtraNotification) {
            await this.setStatusLockedFile(
              this.$route.query.loanNumber,
              notifyId
            )
              .then((resp) => resp.data)
              .catch(() => null);
          }

          this.initEmailModel();
        } else {
          this.$store.commit(
            "statusDialog/showErrorDialog",
            "Sorry, your request failed."
          );
        }
      }
    },
  },
  mixins: [rules],
};
</script>

<style lang="scss" scoped>
.quill-editor-style {
  height: 100%;
}
</style>
